import { render, staticRenderFns } from "./AddPickingBins.vue?vue&type=template&id=16ad4914"
import script from "./AddPickingBins.vue?vue&type=script&lang=js"
export * from "./AddPickingBins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports